/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponsHalResponse } from '../../models/coupons-hal-response';

export interface CouponsIdGet$Params {
  'Active-Tenant-Identifier': string;
  couponId?: string;
}

export function couponsIdGet(http: HttpClient, rootUrl: string, params: CouponsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponsHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('couponId', params.couponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponsHalResponse>;
    })
  );
}

couponsIdGet.PATH = '/coupons/id';
